import React from 'react';

import { getClassNames } from '@RHEnvironmental/pattern-library/dist/js/services/stylingUtils';
import BodyText from '../../modules/BodyText';

import { HARM_SCALE_POINTS } from '../../../constants/HHSRS';

const SpreadOfHarmAccordion = ({
    rating,
    name,
    setRating,
    onToggle,
    isToggled,
    nationalAverage,
}) => {
    const getClasses = (value) =>
        getClassNames('harm-accordion__scale-point', {
            'harm-accordion__scale-point--selected':
                parseFloat(value) === parseFloat(rating),
        });

    return (
        <div className="harm-accordion">
            <div className="harm-accordion__header" onClick={onToggle}>
                <span className="harm-accordion--rating">{rating}%</span>
                <span>{name}</span>
            </div>
            {isToggled && (
                <div>
                    <div className="harm-accordion__scale">
                        {HARM_SCALE_POINTS.map((value) => (
                            <span
                                key={value}
                                className={getClasses(value)}
                                onClick={() => setRating(value)}
                            >
                                {value}
                            </span>
                        ))}
                    </div>
                    <BodyText>National Average: {nationalAverage}</BodyText>
                </div>
            )}
        </div>
    );
};

export default SpreadOfHarmAccordion;
